import { read, utils, writeFileXLSX } from "xlsx"

export const getClassStudentsFromExcel = async (e) => {
    const file = e.target?.files?.[0]
    const data = await file?.arrayBuffer();
    const workbook = read(data);
    for (let sheetName of workbook.SheetNames) {
        if (sheetName === "attestation") {
            const rowObject = utils.sheet_to_json(workbook.Sheets[sheetName])
            const foundIndex = rowObject.findIndex(o => Object.values(o).includes('ID *'))
            if (foundIndex === -1) {
                return [];
            }
            const foundColumn = Object.entries(rowObject[foundIndex]).find(e => e[1] === 'ID *')
            if (!foundColumn) {
                return [];
            }
            const filteredObjects = rowObject.filter(o => Object.entries(o).find(e => e[0] === foundColumn[0] && e[1] !== 'ID *'))
            if (!filteredObjects.length) {
                return []
            }
            return filteredObjects.map(o => Object.entries(o).find(e => e[0] === foundColumn[0])[1])
        }
    }
    return []
}